/**
 * 部署模式配置读取。
 *
 * 私有化生产构建（.env.productionPri）或本地开发（.env.developmentPrivate）中设置：
 *   VUE_APP_DEPLOY_MODE=private
 *   VUE_APP_SHOW_TENANT_CODE=false
 *   VUE_APP_ENABLE_PLATFORM=false
 *   VUE_APP_DEFAULT_TENANT_CODE=your_tenant_code   ← 私有化专用，前端自动携带
 *
 * SaaS 开发/构建（.env.development / .env.production）无需设置这些变量，行为与原来完全相同。
 */

/** 是否私有化部署模式 */
export const isPrivateMode = process.env.VUE_APP_DEPLOY_MODE === 'private'

/** 私有化模式下是否在登录页显示租户码输入框（false = 隐藏并自动填充） */
export const showTenantCode = process.env.VUE_APP_SHOW_TENANT_CODE !== 'false'

/** 是否启用平台超管入口（私有化时应为 false） */
export const enablePlatform = process.env.VUE_APP_ENABLE_PLATFORM !== 'false'

/** 私有化模式下的默认租户码（自动填入登录请求，无需用户输入） */
export const defaultTenantCode = process.env.VUE_APP_DEFAULT_TENANT_CODE || ''
